import { render, staticRenderFns } from "./UploadManager.vue?vue&type=template&id=70c2797c"
import script from "./UploadManager.vue?vue&type=script&lang=js"
export * from "./UploadManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports